import useGlobalStore from '@/store'
import { useShallow } from 'zustand/react/shallow'
import { useEffect, useState } from 'react'

export default function useAuthMenu(list) {
  const [authMenu, setAuthMenu] = useState<any[]>([])

  const { globalMenu } = useGlobalStore(
    useShallow((state: any) => ({
      globalMenu: state.menu,
    }))
  )

  useEffect(() => {
    if (Array.isArray(list) && globalMenu.length) {
      console.log("list", list)
      const authMenu = list
        .filter(
          d =>
            d.app.appType !== 'SYSTEM' &&
            globalMenu.find(m => (m.key === d.code || m.key === d.appCode || m.key === d.app?.code) && m.children?.length)
        )
        .map(d => {
          d.appCode = d.appCode || d.app.code
          return d
        })
      // console.log('list', list, globalMenu)
      setAuthMenu(authMenu)
    }
  }, [globalMenu, list])

  return authMenu
}
